<script>
import { Line } from 'vue-chartjs';
export default {
  extends: Line,
  props: {
    chart_data: Object,
  },
  methods: {
    render() {
      this.renderChart(
        {
          labels: this.chart_data.x_axis,
          datasets: [
            {
              label: 'NPS Score',
              borderColor: '#1ACD82',
              backgroundColor: 'transparent',
              fill: false,
              data: this.chart_data.y_axis,
              tension: 0.2
            }
          ]
        },
        {
          legend: {
            display: false,
          },
          scales: {
            yAxes: [{
                ticks: {
                    stepSize: 10,
                    min: -100,
                    max: 100
                }
            }]
          }
        }
      )
    }
  },
  mounted () {
    this.render();
  }
}
</script>
